import { useEffect, useState } from 'react';
import { Row, Col, Typography, Card, Spin } from 'antd';
import { TeamOutlined, FileTextOutlined, CalendarOutlined } from '@ant-design/icons';
import AppLayout from '../components/common/Layout';
import StatsCard from '../components/cards/StatsCard';
import { adminApi } from '../api/adminApi';

const { Title, Text } = Typography;

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await adminApi.getStats();
        setData(response.data.stats);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <AppLayout>
        <div style={{ textAlign: 'center', padding: 48 }}>
          <Spin size="large" />
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="page-header">
        <Title level={3}>Дашборд</Title>
        <Text type="secondary">Обзор One-to-One отчётов</Text>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <StatsCard title="В команде" value={data?.teamCount || 0} prefix={<TeamOutlined />} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatsCard title="Всего отчётов" value={data?.totalReports || 0} prefix={<FileTextOutlined />} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatsCard
            title="Среднее настроение"
            value={data?.avgMood || 0}
            suffix="/ 10"
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatsCard title="Встреч за неделю" value={data?.meetingsThisWeek || 0} prefix={<CalendarOutlined />} />
        </Col>
      </Row>

      <Card title="Статусы отчётов" style={{ marginTop: 16 }}>
        <Row gutter={16}>
          <Col xs={12} sm={6}>
            <StatsCard title="Ожидают" value={data?.statusDistribution?.pending || 0} />
          </Col>
          <Col xs={12} sm={6}>
            <StatsCard title="Заполнены" value={data?.statusDistribution?.submitted || 0} />
          </Col>
          <Col xs={12} sm={6}>
            <StatsCard title="Завершены" value={data?.statusDistribution?.expired || 0} />
          </Col>
          <Col xs={12} sm={6}>
            <StatsCard title="Обсуждены" value={data?.statusDistribution?.discussed || 0} />
          </Col>
        </Row>
      </Card>
    </AppLayout>
  );
};

export default Dashboard;
